module.exports = "/_next/static/images/cctv-d5d99f49ae49cecaa1930eabaa1d78da.png";